/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./pages/guides_maintenance/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_accessible/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_accessible/index.js

class AddButton {
    get guideId() {
        return this.$btn.data().guideId;
    }
    get btnAddedSuccess() {
        return '<i class="q-icon q-icon-check"></i><span>Guia adicionado!</span>';
    }
    get btnAddGuide() {
        return '<i class="q-icon q-spinner"></i><span>Adicionando...</span>';
    }
    bind() {
        this.$btn.on('click', (e)=>{
            e.preventDefault();
            this.addGuide();
        });
    }
    addGuide() {
        this.$btn.removeClass('btn-secondary');
        this.$btn.addClass('q-add-guide-button');
        this.$btn.html(this.btnAddGuide);
        window.jQuery('q-add-guide-button').prop('disabled', true);
        Thor.UserGuide.create({}, {
            data: {
                guide_id: this.guideId
            }
        }).then(()=>{
            this.$btn.removeClass('q-add-guide-button');
            this.$btn.addClass('q-add-guide-button-success');
            this.$btn.html(this.btnAddedSuccess);
            window.jQuery('.q-add-guide-button-success').prop('disabled', true);
        }).catch((response)=>{
            toastr.error('Ops! Algo deu errado ao salvar este Guia de Estudos. Tente novamente mais tarde ou entre em contato.', response);
            this.$btn.html(this.$btnHtml);
            this.bind();
        });
    }
    _disableBtn() {
        this.$btn.on('click', (e)=>{
            e.preventDefault();
        });
    }
    constructor(btn){
        this.$btn = btn;
        this.$btnHtml = this.$btn.html();
        this.bind();
    }
}
(function($1) {
    const $btn = $1('.js-btn-add-guide', '.q-guides-maintenance-text-info');
    new AddButton($btn);
})(window.jQuery);

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_guide_added/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_guide_added/index.js


;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_logged_out/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_logged_out/index.js


;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_not_accessible/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/info_card_not_accessible/index.js


;// CONCATENATED MODULE: ./pages/guides_maintenance/components/bottom_buttons/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/guides_maintenance/components/bottom_buttons/index.js


;// CONCATENATED MODULE: ./pages/guides_maintenance/index.js







;// CONCATENATED MODULE: ./packs/guides_maintenance.js


/******/ })()
;